var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"app":""}},[_c('v-app-bar-nav-icon',{on:{"click":function($event){return _vm.setDrawer(!_vm.drawer)}}}),_c('v-spacer'),_c('SignOut')],1)}
var staticRenderFns = []

export { render, staticRenderFns }